"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    width: 50%;
    @media screen and ${constants_1.Device.tablet} {
        width: 75%;
    }
    @media screen and ${constants_1.Device.mobileL} {
        width: 100%;
    }
    hr {
        width: 50%;
        border-color: #e8e8e8;
    }
    .itemTitle {
        font-family: OpenSans, sans-serif;
        font-size: 24px;
        letter-spacing: 1.2px;
        color: #1e1e1e;
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;
        @media screen and ${constants_1.Device.mobileL} {
            font-size: 14px;
        }
    }
    .itemDescription {
        margin: 0.5em 0 0;
        font-family: OpenSans, sans-serif;
        font-weight: 400;
        font-size: 14px;
        letter-spacing: 0.59px;
        text-align: center;
        @media screen and ${constants_1.Device.mobileL} {
            font-size: 12px;
            font-weight: 400;
        }
    }
    .buttonContainer {
        margin-top: 40px;
    }
    .errorData {
        text-align: center;
        font-family: OpenSans, sans-serif;
        font-size: 14px;
        div {
            &.uppercase {
                text-transform: uppercase;
            }
            margin: 0;
        }
        .errorPrimary {
            color: #1e1e1e;
        }
        .errorSecondary {
            font-size: 16px;
        }
    }
`;
//# sourceMappingURL=ConfirmStageStyled.js.map